/**
 * Illustrations stickers (SVG) — rendu « die-cut » avec brillance et ombre.
 */

function LeafMotif() {
  return (
    <g>
      <path d="M100 28c-28 18-48 48-48 78 0 28 20 46 48 46s48-18 48-46c0-30-20-60-48-78z" fill="#3d8b4f" />
      <path d="M100 38c-22 16-38 42-38 68 0 22 16 36 38 36s38-14 38-36c0-26-16-52-38-68z" fill="#57b06a" />
      <path d="M100 42v96" stroke="#1a472a" strokeWidth="3" strokeLinecap="round" opacity="0.55" />
      <path d="M100 70c-14 6-24 16-30 28M100 90c14 6 24 16 30 28M100 58c-12 4-22 12-28 22M100 78c12 4 22 12 28 22" stroke="#1a4720" strokeWidth="2" fill="none" opacity="0.45" strokeLinecap="round" />
    </g>
  )
}

function CottageMotif() {
  return (
    <g>
      <ellipse cx="100" cy="155" rx="58" ry="10" fill="#1a472a" opacity="0.15" />
      <path d="M42 108 L100 52 L158 108 Z" fill="#8b5a3c" />
      <path d="M52 108 L100 62 L148 108 Z" fill="#a66d48" />
      <rect x="58" y="108" width="84" height="48" rx="4" fill="#f5efe2" />
      <rect x="88" y="120" width="24" height="36" rx="2" fill="#5a3a24" />
      <rect x="68" y="118" width="14" height="14" rx="2" fill="#5a9aa8" />
      <rect x="118" y="118" width="14" height="14" rx="2" fill="#5a9aa8" />
      <circle cx="148" cy="72" r="14" fill="#d4a017" opacity="0.9" />
      <path d="M30 148 Q100 128 170 148" stroke="#2d6640" strokeWidth="8" fill="none" strokeLinecap="round" />
      <path d="M48 140 Q70 120 78 138" fill="#4a7c2a" />
      <path d="M122 138 Q140 118 158 142" fill="#3d8b4f" />
    </g>
  )
}

function OrchardMotif() {
  return (
    <g>
      <circle cx="100" cy="100" r="62" fill="none" stroke="#c45c26" strokeWidth="6" strokeDasharray="8 10" opacity="0.7" />
      <circle cx="100" cy="100" r="40" fill="none" stroke="#d4a017" strokeWidth="3" opacity="0.5" />
      {[0, 60, 120, 180, 240, 300].map((angle) => {
        const rad = (angle * Math.PI) / 180
        const x = 100 + Math.cos(rad) * 48
        const y = 100 + Math.sin(rad) * 48
        return (
          <g key={angle}>
            <circle cx={x} cy={y} r="12" fill="#57b06a" />
            <circle cx={x - 3} cy={y - 2} r="3.5" fill="#e85d4c" />
            <circle cx={x + 4} cy={y + 3} r="2.5" fill="#f0b429" />
          </g>
        )
      })}
      <circle cx="100" cy="100" r="16" fill="#3d8b4f" />
      <path d="M100 88 v24 M88 100 h24" stroke="#f5efe2" strokeWidth="3" strokeLinecap="round" />
    </g>
  )
}

function SunMotif() {
  return (
    <g>
      {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => {
        const rad = (angle * Math.PI) / 180
        const x1 = 100 + Math.cos(rad) * 42
        const y1 = 100 + Math.sin(rad) * 42
        const x2 = 100 + Math.cos(rad) * 68
        const y2 = 100 + Math.sin(rad) * 68
        return (
          <line
            key={angle}
            x1={x1}
            y1={y1}
            x2={x2}
            y2={y2}
            stroke="#d4a017"
            strokeWidth="8"
            strokeLinecap="round"
          />
        )
      })}
      <circle cx="100" cy="100" r="36" fill="#f0b429" />
      <circle cx="100" cy="100" r="28" fill="#ffd666" />
      <path d="M88 98c2-6 8-10 12-10s10 4 12 10" stroke="#8b5a3c" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <circle cx="90" cy="92" r="3" fill="#8b5a3c" />
      <circle cx="110" cy="92" r="3" fill="#8b5a3c" />
    </g>
  )
}

function EmblemMotif() {
  return (
    <g>
      <circle cx="100" cy="100" r="58" fill="#1a472a" />
      <circle cx="100" cy="100" r="48" fill="none" stroke="#d4a017" strokeWidth="3" />
      <path d="M100 58c-18 14-30 34-30 52 0 18 12 30 30 30s30-12 30-30c0-18-12-38-30-52z" fill="#57b06a" />
      <path d="M100 72v56" stroke="#f5efe2" strokeWidth="2.5" strokeLinecap="round" opacity="0.8" />
      <text x="100" y="168" textAnchor="middle" fill="#d4a017" fontSize="14" fontWeight="700" fontFamily="Inter, sans-serif">
        N&amp;G
      </text>
    </g>
  )
}

function WildMotif() {
  return (
    <g>
      <path d="M20 140 Q60 90 100 130 Q140 80 180 140" fill="#2d6640" />
      <path d="M30 140 Q70 100 100 135 Q135 95 170 140" fill="#3d8b4f" />
      <path d="M55 140 L70 70 L85 140 Z" fill="#1a472a" />
      <path d="M115 140 L135 55 L155 140 Z" fill="#1a472a" />
      <path d="M90 140 L100 85 L110 140 Z" fill="#0f2e1a" />
      <circle cx="150" cy="55" r="16" fill="#f5efe2" opacity="0.85" />
      <path d="M40 155 h120" stroke="#8b5a3c" strokeWidth="6" strokeLinecap="round" opacity="0.4" />
    </g>
  )
}

function PackNatureMotif() {
  return (
    <g>
      <rect x="48" y="58" width="70" height="70" rx="14" fill="#57b06a" transform="rotate(-12 83 93)" />
      <rect x="72" y="52" width="70" height="70" rx="14" fill="#d4a017" transform="rotate(8 107 87)" />
      <rect x="58" y="72" width="70" height="70" rx="14" fill="#3d8b4f" />
      <path d="M93 88c-8 6-14 14-14 24 0 8 6 14 14 14s14-6 14-14c0-10-6-18-14-24z" fill="#f5efe2" />
      <circle cx="118" cy="78" r="10" fill="#ffd666" />
      <text x="93" y="160" textAnchor="middle" fill="#1a472a" fontSize="13" fontWeight="700" fontFamily="Inter, sans-serif">
        ×6
      </text>
    </g>
  )
}

function PackAdventureMotif() {
  return (
    <g>
      <rect x="45" y="55" width="68" height="68" rx="14" fill="#5a9aa8" transform="rotate(-10 79 89)" />
      <rect x="78" y="50" width="68" height="68" rx="14" fill="#8b5a3c" transform="rotate(12 112 84)" />
      <rect x="58" y="70" width="72" height="72" rx="14" fill="#2d6640" />
      <path d="M78 118 L94 88 L110 118 Z" fill="#f5efe2" />
      <circle cx="120" cy="92" r="9" fill="#d4a017" />
      <path d="M82 100 h30" stroke="#a8e6b0" strokeWidth="3" strokeLinecap="round" />
      <text x="94" y="162" textAnchor="middle" fill="#1a472a" fontSize="13" fontWeight="700" fontFamily="Inter, sans-serif">
        ×8
      </text>
    </g>
  )
}

const MOTIFS = {
  leaf: LeafMotif,
  cottage: CottageMotif,
  orchard: OrchardMotif,
  sun: SunMotif,
  emblem: EmblemMotif,
  wild: WildMotif,
  packNature: PackNatureMotif,
  packAdventure: PackAdventureMotif,
}

export default function StickerArt({
  motif = 'leaf',
  accent = '#3d8b4f',
  glow = '#a8e6b0',
  className = '',
  rotate = 0,
  animated = false,
}) {
  const Motif = MOTIFS[motif] || LeafMotif

  return (
    <div
      className={`sticker-art relative ${className}`}
      style={{
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <div
        className={`relative aspect-square w-full overflow-hidden rounded-[28%] bg-white shadow-[0_12px_28px_rgba(26,71,42,0.18),0_2px_0_rgba(255,255,255,0.9)_inset] ring-1 ring-black/5 ${
          animated ? 'sticker-art-pop' : ''
        }`}
        style={{
          background: `radial-gradient(circle at 30% 25%, ${glow}55 0%, #ffffff 48%, #f7f3ea 100%)`,
        }}
      >
        <div
          className="pointer-events-none absolute inset-0 opacity-40"
          style={{
            background: `radial-gradient(circle at 70% 80%, ${accent}22 0%, transparent 55%)`,
          }}
          aria-hidden="true"
        />
        <div
          className="pointer-events-none absolute -left-1/4 -top-1/3 h-2/3 w-2/3 rounded-full bg-white/50 blur-xl"
          aria-hidden="true"
        />
        <svg viewBox="0 0 200 200" className="relative h-full w-full p-[8%]" aria-hidden="true">
          <Motif />
        </svg>
        <div
          className="pointer-events-none absolute inset-x-[18%] top-[10%] h-[22%] rounded-full bg-gradient-to-b from-white/70 to-transparent"
          aria-hidden="true"
        />
      </div>
    </div>
  )
}
